import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { C } from '../../theme/palette';

export function EcranAVenir({ route }) {
  const noms = { chantiers: 'Chantiers', factures: 'Factures', ventes: 'Ventes', plus: 'Plus' };
  return (
    <Card>
      <Bar icon="🚧" title={noms[route] || route} color={C.navy} />
      <div
        style={{ padding: 24, textAlign: 'center', color: C.muted, fontSize: 11, lineHeight: 1.6 }}
      >
        Cet écran arrive au prochain module — avec tous ses détails.
        <br />
        Accueil et Devis, eux, sont déjà complets.
      </div>
    </Card>
  );
}
